import Handlebars from "handlebars";
import truncate from "./truncate.js";
import filetype from "./filetype.js";
import filesize from "./filesize.js";
import defaultValue from "./defaultValue.js";
import is_equal from "./is_equal.js";
import is_link from "./is_link.js";

Handlebars.registerHelper('truncate',truncate)
Handlebars.registerHelper('filesize',filesize)
Handlebars.registerHelper('filetype',filetype)
Handlebars.registerHelper('defaultValue',defaultValue)
Handlebars.registerHelper('is_equal',is_equal)
Handlebars.registerHelper('is_link',is_link)



const templateString= `
<style>
.asset-card{
   position: relative !important;
   cursor: pointer;
}

.asset-card .tooltip-text {
  visibility: hidden;
  opacity: 0;
  background-color: #2B2B2B;
  color: #fff;
  text-align: center;
  max-width: 11.25rem !important;
  width: fit-content;
  overflow-wrap: break-word !important;
  border-radius: 0.188rem;
  padding: 0.25rem 0.375rem;
  font-size: 0.625rem !important;
  position: absolute;
  z-index: 99;
  bottom: 160%;
  transition: opacity 0.3s ease-out;
  left: 40%;
  margin-left: -3.75rem;

}

.asset-card .tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -0.3125;
  border-width: 0.3125;
  border-style: solid;
  border-color: #2B2B2B transparent transparent transparent;
}

.asset-card:hover .tooltip-text{
  visibility: visible;
  opacity: 1;
}
</style>
<table width="220" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; width: 220px; background-color: #f5f5f5; border-radius: 12px;">
  <tr>
    <td width="60" style="padding: 10px; width: 60px; vertical-align: top;">
      {{#is_equal type 'asset'}}
      <a data-index="{{@index}}" href="{{defaultValue @root.contact.url '{{{contact.url}}}'}}/assets/{{asset.id}}" data-widget-placeholder="\{{contact.url}}/collections/\{{share.id}}{{#is_equal asset.viewerType 'DEAL_ROOM'}}/resources{{/is_equal}}/a/\{{share.assets.[{{@index}}].id}}"
        style="font-weight: 600; font-size: 12px; color: #060606; text-decoration: none;">
        <img src="{{asset.icon.thumbnail}}" width="48" height="48" data-widget-placeholder="\{{apiUrl}}/shared_url/\{{share.id}}/asset/\{{share.assets.[{{@index}}].id}}/icon"
          style="display: block; width: 48px; height: 48px; object-fit: cover; border-radius: 8px;" />
      </a>
      {{/is_equal}}
    </td>
    <td width="220" style="padding-top: 10px; padding-right: 10px; vertical-align: top;">
      <div style="padding-right: 10px;">
        <div style="margin: 0 0 5px 0;">
          {{#is_equal type 'file'}} 
            <span style="font-weight: 500; font-size: 12px; color: #060606; font-family: {{defaultValue @root.theme.brandFont 'gilroy'}};">
              {{truncate file.name.name 20}}
            </span>
          {{/is_equal}} 
          
          {{#is_equal type 'asset'}}
          <a data-index="{{@index}}" href="{{defaultValue @root.contact.url '{{{contact.url}}}'}}/assets/{{asset.id}}" data-widget-placeholder="\{{contact.url}}/collections/\{{share.id}}{{#is_equal asset.viewerType 'DEAL_ROOM'}}/resources{{/is_equal}}/a/\{{share.assets.[{{@index}}].id}}"
            style="display: block; font-weight: 600; font-size: 12px; color: #060606; font-family: {{defaultValue @root.theme.brandFont 'gilroy'}}; text-decoration: none;">
            {{truncate asset.name 20}}
          </a>
          {{/is_equal}}
        </div>
        <div style="font-size: 12px; color: #a9a9a9; font-family: {{defaultValue @root.theme.brandFont 'gilroy'}};">
          {{#is_equal type 'file'}} 
            Uploading... 
          {{/is_equal}} 
          
          {{#is_equal type 'asset'}}
          <a data-index="{{@index}}" href="{{defaultValue @root.contact.url '{{{contact.url}}}'}}/assets/{{asset.id}}" data-widget-placeholder="\{{contact.url}}/collections/\{{share.id}}{{#is_equal asset.viewerType 'DEAL_ROOM'}}/resources{{/is_equal}}/a/\{{share.assets.[{{@index}}].id}}"
            style="font-weight: 600; font-size: 12px; color: #717274; font-family: {{defaultValue @root.theme.brandFont 'gilroy'}}; text-decoration: none;">
            {{#if (is_link asset.metadata)}}
              {{filetype asset.metadata}}
            {{else}}
              {{filesize asset.metadata}} 
              <span style="display: inline-block; width: 1px; height: 10px; background-color: #DBDBDB; margin: 0 8px;">&nbsp;</span>
              {{filetype asset.metadata}}
            {{/if}}
          </a>
          {{/is_equal}}
        </div>
      </div>
    </td>
  </tr>
</table>

`

const template = Handlebars.compile(templateString)

export default template;